import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'dprModalTitle',
})
export class DprModalTitlePipe implements PipeTransform {
  transform(dprInfo: string, actionText: string): string {
    return $localize`:@@dpr.dprCardModalTitlePipe.titleModal:${dprInfo}:dprInfo:: ${actionText}:actionText:`;
  }
}
